/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-23 11:24:19
 * @modify date 2021-08-23 11:24:19
 * @desc [枚举]
 */
/**
 * @export 通知类型
 * @enum
 */
export var EnumMicroNoticeType;
(function (EnumMicroNoticeType) {
    EnumMicroNoticeType["RouteChange"] = "RouteChange";
})(EnumMicroNoticeType || (EnumMicroNoticeType = {}));
export var EnumMicroApp;
(function (EnumMicroApp) {
    /** 微前端路径 */
    EnumMicroApp["MicroPage"] = "/micro/";
    /** Iframe路径 */
    EnumMicroApp["IframePage"] = "/webview/";
    /** 应用名称 key */
    EnumMicroApp["APP"] = "app";
    /** Protal 路径标记 */
    EnumMicroApp["Protal"] = "@Protal";
})(EnumMicroApp || (EnumMicroApp = {}));
/**
 * 路由类型
 * @export
 * @enum {number}
 */
export var EnumMicroHistory;
(function (EnumMicroHistory) {
    /** 平台内置 */
    EnumMicroHistory["Browser"] = "browser";
    /** 微应用 */
    EnumMicroHistory["Hash"] = "hash";
})(EnumMicroHistory || (EnumMicroHistory = {}));
